package ai.jessie.shared.invoices

import kotlinx.serialization.Serializable

// UC-015 / FR-015. Artefact availability of an issued invoice; the PDFs are binary responses.
// invoicePdf: LINKED, NOT_LINKED (generated on first retrieval) or SNAPSHOT_UNAVAILABLE (A6).
// workReport: NO_IMPORTED_WORK, AVAILABLE (may be requested), LINKED or UNAVAILABLE (A3).
// Refusals use InvoiceProblemResponse codes INVOICE_NOT_ISSUED (A5), SNAPSHOT_UNAVAILABLE (A6),
// WORK_REPORT_UNAVAILABLE (A3) and WORK_REPORT_NOT_REQUESTED.
@Serializable
data class InvoiceArtefactsResponse(
    val invoiceId: String,
    val invoicePdf: String,
    val workReport: String,
)
